'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _arrowDown = require('dibs-vg/dist/react/arrow-down');

var _arrowDown2 = _interopRequireDefault(_arrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DurationSelect = function (_Component) {
    (0, _inherits3.default)(DurationSelect, _Component);

    function DurationSelect(props) {
        (0, _classCallCheck3.default)(this, DurationSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DurationSelect.__proto__ || (0, _getPrototypeOf2.default)(DurationSelect)).call(this, props));

        _this.setOptionElements = _this.setOptionElements.bind(_this);
        _this.setOptionElements(props.durations);
        return _this;
    }

    (0, _createClass3.default)(DurationSelect, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var durations = nextProps.durations;

            if (durations !== this.props.durations) {
                this.setOptionElements(durations);
            }
        }
    }, {
        key: 'setOptionElements',
        value: function setOptionElements(durations) {
            this._optionElements = durations.map(function (days) {
                var text = void 0;
                if (days === -1) {
                    text = 'no expiration';
                } else {
                    text = days + ' ' + (days === 1 ? 'day' : 'days');
                }
                return _react2.default.createElement(
                    'option',
                    { key: days, value: days },
                    text
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var theme = this.props.theme;

            return theme ? _react2.default.createElement(
                'label',
                { className: theme.expirationLabel },
                this.props.label,
                _react2.default.createElement(_arrowDown2.default, { className: theme.arrow }),
                _react2.default.createElement(
                    'select',
                    {
                        name: this.props.name,
                        className: theme.expirationSelect,
                        value: this.props.value,
                        disabled: this.props.disabled,
                        onChange: function onChange(e) {
                            return _this2.props.onChange(parseInt(e.target.value));
                        }
                    },
                    this._optionElements
                )
            ) : null;
        }
    }]);
    return DurationSelect;
}(_react.Component);

exports.default = DurationSelect;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/DurationSelect/index.js
// module id = 854
// module chunks = 4 5 8 9 14